(function () {
    'use strict';

    angular
        .module('signalrControllers', ['services.configuration']);
})();
